/**
 * Treat — search drawer suggestions.
 *
 * Keeps the shopper's last five searches in this browser (localStorage, never sent anywhere)
 * and lists them in the drawer as links to the search page, with a Clear button. A search is
 * recorded when the form is submitted. Everything degrades silently when storage is blocked.
 */
if (!customElements.get('treat-search-suggestions')) {
  const STORAGE_KEY = 'treat:recent-searches';
  const MAX_TERMS = 5;

  const readTerms = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(stored) ? stored.filter((term) => typeof term === 'string') : [];
    } catch (error) {
      return [];
    }
  };

  const writeTerms = (terms) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(terms.slice(0, MAX_TERMS)));
    } catch (error) {
      /* storage blocked: recent searches simply stay off */
    }
  };

  customElements.define(
    'treat-search-suggestions',
    class TreatSearchSuggestions extends HTMLElement {
      connectedCallback() {
        this.group = this.querySelector('[data-recent]');
        this.list = this.querySelector('[data-recent-list]');
        const modal = this.closest('.search-modal');
        this.form = modal ? modal.querySelector('form[role="search"]') : null;

        if (this.form) {
          this.form.addEventListener('submit', () => {
            const input = this.form.querySelector('input[name="q"]');
            const term = input ? input.value.trim() : '';
            if (term) this.remember(term);
          });
        }

        const clear = this.querySelector('[data-recent-clear]');
        if (clear) {
          clear.addEventListener('click', () => {
            writeTerms([]);
            this.render();
          });
        }

        this.render();
      }

      remember(term) {
        const lower = term.toLowerCase();
        const terms = readTerms().filter((existing) => existing.toLowerCase() !== lower);
        terms.unshift(term);
        writeTerms(terms);
      }

      render() {
        if (!this.group || !this.list) return;
        const terms = readTerms();
        this.list.replaceChildren(
          ...terms.map((term) => {
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.className = 'treat-search-suggestions__term link';
            const action = (this.form && this.form.getAttribute('action')) || '/search';
            link.href = `${action}?q=${encodeURIComponent(term)}`;
            link.textContent = term;
            item.appendChild(link);
            return item;
          })
        );
        this.group.hidden = terms.length === 0;
      }
    }
  );
}
